/** The manual payment-source picker shown by `RecordPaymentDrawer` and the
 *  bulk mark-paid confirm dialog (design doc §2: "the confirm dialog carries
 *  the source picker, same options as RecordPaymentDrawer's"). Extracted here
 *  so the two surfaces can't drift on the option list, the icon per source,
 *  or the type — both read the i18n label through `payments:drawer.source.*`. */
import type { ComponentType } from 'react';
import { Banknote, Building2, ShoppingBag, MoreHorizontal } from 'lucide-react';
import { MANUAL_SOURCES } from '@repo/validation';

export type ManualSource = (typeof MANUAL_SOURCES)[number];

export const MANUAL_SOURCE_OPTIONS: Array<{
  value: ManualSource;
  icon: ComponentType<{ className?: string; strokeWidth?: number }>;
}> = [
  { value: 'CASH', icon: Banknote },
  { value: 'MANUAL_BANK', icon: Building2 },
  { value: 'ECOMMERCE', icon: ShoppingBag },
  { value: 'OTHER', icon: MoreHorizontal },
];
